import { ReactElement } from 'react'

const Day = (): ReactElement => {
  /* function body */
  return <div />
}

export default Day
